import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=fe7d06dc&"
import script from "./MenuView.vue?vue&type=script&lang=js&"
export * from "./MenuView.vue?vue&type=script&lang=js&"
import style0 from "./MenuView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports